import { FrontMetadata } from "./FrontMetadata";

export class FrontFaceMetadata {
    Index: number = 0;
    FrontElements: FrontMetadata[] = [];
}